var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2 4.0026H3.33333M3.33333 4.0026H14M3.33333 4.0026V13.3359C3.33333 13.6896 3.47381 14.0287 3.72386 14.2787C3.97391 14.5288 4.31304 14.6693 4.66667 14.6693H11.3333C11.687 14.6693 12.0261 14.5288 12.2761 14.2787C12.5262 14.0287 12.6667 13.6896 12.6667 13.3359V4.0026H3.33333ZM5.33333 4.0026V2.66927C5.33333 2.31565 5.47381 1.97651 5.72386 1.72646C5.97391 1.47641 6.31304 1.33594 6.66667 1.33594H9.33333C9.68696 1.33594 10.0261 1.47641 10.2761 1.72646C10.5262 1.97651 10.6667 2.31565 10.6667 2.66927V4.0026M6.66667 7.33594V11.3359M9.33333 7.33594V11.3359",
    stroke: "#B42318",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/RedTrash.193584f95b04ed92857b5e34c27333f1.svg";
export { ForwardRef as ReactComponent };